<template lang="pug">
  .the-b2b-tags-component
    .the-b2b-tags-component__container(v-if='tags.length > 0')
      transition-group.the-b2b-tags-component__group(
        name='ods-fade-in-linear',
        tag='div',
        :key='updateFilterTags')
        ods-popover(
          :disabled='!isFilter',
          key='icon-delete-filters',
          placement='top-start',
          trigger='hover',
          :content='$t("msg_generics.popover_clean_filters")')
          ods-button.clean-filters(
            slot='reference',
            type='neutral',
            size='small',
            icon='ods-icon-delete'
            @click='removeAllButtonAction')
        .the-b2b-tags-component__button(
          v-for='(filter, index) in tags',
          :key='index')
          b2b-filter-button(
            :filter='filter',
            @delete-filter='removeTag')
</template>

<script>
import B2bFilterButton from '@/components/B2bFilterButton'

export default {
  name: 'b2b-tags-component',
  props: {
    tags: {
      type: Array,
      required: true
    },
    isFilter: {
      type: Boolean,
      default: true
    }
  },

  components: {
    B2bFilterButton
  },

  data () {
    return {
      updateFilterTags: 0
    }
  },

  methods: {
    removeAllButtonAction () {
      this.$emit('when-remove-all')
    },

    removeTag (tag) {
      if (tag == null) {
        return
      }
      this.$emit('when-remove', tag)
    }
  },

  mounted () {
    this.$data.updateFilterTags = 0
  }
}
</script>

<style lang="scss" scoped>
.the-b2b-tags-component {
  &__group {
    padding: 0 1.5rem 1.25rem 1.5rem;
    height: auto;
    background-color: white;
    .clean-filters {
      color: var(--color-status-info-400);
      .ods-icon-delete {
        margin-left: 0px;
      }
    }
  }

  &__button {
    margin: 0 0 0 1.25rem;
    display: inline-block;
    width: auto;
  }
}
</style>
